import { useCallback, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { userState } from "@/store";
import { useCustomer } from "@/hooks/use-customer";
import { useGomakeAxios, useSnackBar } from "@/hooks";
import { setUseDirectQrHandlerApi } from "@/services/api-service/users/users-api";

const useDirectQrHandlerToggle = () => {
  const user = useRecoilValue<any>(userState);
  const userId = user?.id ?? user?.userId;
  const { validate } = useCustomer();
  const { callApi } = useGomakeAxios();
  const { alertFaultUpdate } = useSnackBar();
  const [isUseDirectQrHandler, setIsUseDirectQrHandler] = useState(
    !!user?.isUseDirectQrHandler
  );
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    setIsUseDirectQrHandler(!!user?.isUseDirectQrHandler);
  }, [user?.isUseDirectQrHandler]);

  const onToggle = useCallback(
    async (checked: boolean) => {
      if (!userId || isUpdating) {
        return;
      }
      setIsUseDirectQrHandler(checked);
      setIsUpdating(true);
      try {
        const res = await setUseDirectQrHandlerApi(callApi, () => {}, {
          userId,
          isUseDirectQrHandler: checked,
        });
        if (res?.success) {
          await validate();
        } else {
          setIsUseDirectQrHandler(!checked);
          alertFaultUpdate();
        }
      } catch {
        setIsUseDirectQrHandler(!checked);
        alertFaultUpdate();
      } finally {
        setIsUpdating(false);
      }
    },
    [userId, isUpdating, callApi, validate, alertFaultUpdate]
  );

  return {
    isUseDirectQrHandler,
    isUpdating,
    userId,
    onToggle,
  };
};

export { useDirectQrHandlerToggle };
